// Letris — one-shot WS helpers (global leaderboard).
// Uses ephemeral connections so they don't collide with the long-lived DuelConn.

const DEFAULT_URL = 'ws://localhost:8787';
const URL_RAW = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_WS_URL) || DEFAULT_URL;

function resolveWsUrl(raw) {
  if (!raw) return DEFAULT_URL;
  if (raw.startsWith('ws://') || raw.startsWith('wss://')) return raw;
  if (typeof window === 'undefined' || !window.location) return raw;
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const path = raw.startsWith('/') ? raw : '/' + raw;
  return `${proto}//${window.location.host}${path}`;
}
const WS_URL = resolveWsUrl(URL_RAW);

function oneShot(req, expected, timeoutMs = 6000) {
  return new Promise((resolve) => {
    let ws;
    try { ws = new WebSocket(WS_URL); }
    catch { resolve(null); return; }
    let done = false;
    const finish = (v) => {
      if (done) return;
      done = true;
      try { ws.close(); } catch {}
      resolve(v);
    };
    const timer = setTimeout(() => finish(null), timeoutMs);
    ws.onopen = () => {
      try {
        if (req.hello) ws.send(JSON.stringify(req.hello));
        ws.send(JSON.stringify(req.payload));
      } catch { finish(null); }
    };
    ws.onmessage = (ev) => {
      let m;
      try { m = JSON.parse(ev.data); } catch { return; }
      if (m.t === expected) { clearTimeout(timer); finish(m); }
    };
    ws.onerror = () => { clearTimeout(timer); finish(null); };
    ws.onclose = () => { clearTimeout(timer); finish(null); };
  });
}

export function submitScore({ name, elo, mode, score, level }) {
  return oneShot({
    hello: { t: 'hello', name, elo: elo || 1000 },
    payload: { t: 'submit_score', mode, name, score, level },
  }, 'score_submitted');
}

export function fetchLeaderboard() {
  return oneShot({
    hello: { t: 'hello', name: 'spectator', elo: 1000 },
    payload: { t: 'get_leaderboard' },
  }, 'leaderboard');
}
